
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const apiurl = 'This is my variable'

export default new Vuex.Store({
  state: {
    apiurl: 'http://localhost:4000',
    snackbartext: '',
    snackbartype:'',
    snackbartimeout: 0,
  },

  mutations: {
    setSnackbar(type, message, timeout) {
      this.state.snackbartext = message;
      this.state.snackbartype = type;
      this.state.snackbartimeout = timeout;
    },
  },

  

})
